import type React from 'react'

/**
 * The pointer-interactive wrapper every port (and the Text Tool hover "+") is mounted in. It
 * re-enables pointer events under the layer's `pointerEvents: none` root and stops `pointerdown`
 * so a port press never reaches the canvas beneath. `onClick`/`cursor` are set only by the Text
 * Tool hover "+", which takes its click on the whole group.
 */
export function PortGroup({
  onClick,
  cursor,
  children,
}: {
  onClick?: () => void
  cursor?: string
  children: React.ReactNode
}): React.JSX.Element {
  return (
    <g
      data-text-link-port="true"
      style={{ pointerEvents: 'auto' }}
      onPointerDown={(e) => e.stopPropagation()}
      onClick={onClick}
      cursor={cursor}
    >
      {children}
    </g>
  )
}
